import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'motion/react';

const THINKING_PHRASES = [
  'getting user insights',
  'checking your created exercises',
  'exploring exercises to give the workout a new flavor',
  'curating results',
  'finalizing workout intensity',
  'validating the workout',
];

const PHRASE_DURATION = 2500; // 2.5 seconds per phrase

interface WorkoutGenerationCarouselProps {
  isVisible: boolean;
}

export function WorkoutGenerationCarousel({ isVisible }: WorkoutGenerationCarouselProps) {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (!isVisible) {
      setCurrentIndex(0);
      return;
    }

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % THINKING_PHRASES.length);
    }, PHRASE_DURATION);

    return () => clearInterval(interval);
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-neutral-50/95 backdrop-blur-sm z-50 flex items-center justify-center">
      <div className="text-center px-6">
        {/* Loading indicator */}
        <div className="flex justify-center gap-2 mb-8">
          {[0, 1, 2].map((i) => (
            <motion.div
              key={i}
              className="w-2 h-2 bg-neutral-400 rounded-full"
              animate={{
                scale: [1, 1.2, 1],
                opacity: [0.5, 1, 0.5],
              }}
              transition={{
                duration: 1.2,
                repeat: Infinity,
                delay: i * 0.2,
                ease: 'easeInOut',
              }}
            />
          ))}
        </div>

        {/* Phrase carousel */}
        <div className="h-16 flex items-center justify-center">
          <AnimatePresence mode="wait">
            <motion.p
              key={currentIndex}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.4 }}
              className="text-2xl text-neutral-900"
            >
              {THINKING_PHRASES[currentIndex]}
            </motion.p>
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
}

